exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\n  font-size: 27px;\n  line-height: 5px; }\n\nh3 {\n  font-size: 18px;\n  line-height: 40px; }\n\np.light {\n  font-weight: 550; }\n\n.weekDays-selector input {\n  display: none !important; }\n\n.weekDays-selector input[type=checkbox] + label {\n  display: inline-block;\n  border-radius: 6px;\n  background: #dddddd;\n  height: 40px;\n  width: 34.2px;\n  margin-right: 3px;\n  line-height: 40px;\n  text-align: center;\n  cursor: pointer; }\n\n.weekDays-selector input[type=checkbox]:checked + label {\n  background: #2AD705;\n  color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/edit-sche/edit-sche.component.scss
// module id = ../../../../../src/app/edit-sche/edit-sche.component.scss
// module chunks = main